<div style="position: absolute; width: 100vw;">
  <router-outlet></router-outlet>
  <app-footer [showFull]="false" [isLogin]="false"></app-footer>
</div>
